import React, { useState } from 'react';
import { Link } from 'react-router';
import { Icon, Col, Row, Modal} from 'antd';

import DateViewer from '../../DateViewer';
import VideoManager from '../../Modals/VideoManager';

import icons from "../../icons/icons";

import Icons from './Icons';
import Player from './Player';
import EditButton from '../Info/EditButton';

const Info = ({
  entry,
  user,
  data,
  markerLoading,
  loadingImportVideo,
  setStateHandler,
}) => {
  const { saveLoadingOptions, userClaims } = user;
  const { savingEvent } = saveLoadingOptions;

  const [ visible, setVisible ] = useState(false);

  let isContributorHasRightForChannel = false;
  if (data.channels && user.uid) {
    const channelDetailsInfo = data.channels.filter(channel => channel.id === entry.channel.id)[0];
    const channelContributors = (channelDetailsInfo && channelDetailsInfo.ownerId) || [];
    isContributorHasRightForChannel = channelContributors.indexOf(user.uid) !== -1;
  }

  const showEditButtons = userClaims.userType && (userClaims.userType === 'Admin' || isContributorHasRightForChannel);

  return (
    <div className="event">
      <Row>
        <Col xs={24} md={18}>
          <h1>{entry.title}</h1>
        </Col>
        <Col xs={24} md={6} className="event-date">
          {<DateViewer date={entry.date} isExact={true}/>}
        </Col>
      </Row>

      <Row>
        <Col xs={24} md={18}>
          {
            entry.channel && (
              <div className="event-channel">
                <Link
                  className="link"
                  to={`/Channels/${entry.channel.id}`}
                >
                  <Icon component={icons.channels} /> {entry.channel.title}
                </Link>
              </div>
            )
          }
          <div className="event-text">{entry.description}</div>
          <EditButton 
            showEditButtons={showEditButtons}
            entry={entry}
            setVisible={setVisible}
            loadingImportVideo={loadingImportVideo}
            setStateHandler={setStateHandler} 
          />
        </Col>
      </Row>

      <div className="event-placeholder">
        <Player entry={entry} />
      </div>

      <div className="event-meta">
        <Icons
          entry={entry}
          setStateHandler={setStateHandler}
          savingEvent={savingEvent}
          user={user}
        />
      </div>

      <Modal
        title={`Event title: ${entry.title}`}
        visible={visible}
        onOk={() => setVisible(false)}
        onCancel={() => setVisible(false)}
        width={"90%"}
        height={"70vh"}
      >
        <VideoManager
          event={entry}
          channel={entry && entry.channel}
        />
      </Modal>
    </div>
  )
};

export default Info;



// WEBPACK FOOTER //
// ./src/components/Modules/Info/index.js